import { useMutation } from "@tanstack/react-query";
import { generateStudyReport } from "@/api/client";

export function useGenerateReport() {
  return useMutation({
    mutationFn: generateStudyReport,
  });
}
